/** Fecha ISO `YYYY-MM-DD` del día local. */
export function todayIsoDate(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** `start` debe ser estrictamente anterior a `end` (fechas ISO). */
export function isValidDateRange(start: string, end: string): boolean {
  return start.length > 0 && end.length > 0 && start < end;
}

/**
 * Solapamiento inclusivo entre dos rangos de fechas ISO (`YYYY-MM-DD`).
 */
export function isDateRangeOverlapping(
  startA: string,
  endA: string,
  startB: string,
  endB: string,
): boolean {
  return startA <= endB && startB <= endA;
}

export function isDateWithinRange(
  date: string,
  rangeStart: string,
  rangeEnd: string,
): boolean {
  return date >= rangeStart && date <= rangeEnd;
}
